import { SearchDefinitionModel } from '@anecdotes/design-system/data-manipulation';
import { ChangeDetectionStrategy, Component, HostBinding, OnInit } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import {
  ProfileResponse,
  TrustCenterFacadeService,
  TrustCenterSharedModalsService,
} from '@anecdotes/shared-trust-center';

@Component({
  selector: 'app-permission-profiles-settings',
  templateUrl: './permission-profiles-settings.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class PermissionProfilesSettingsComponent implements OnInit {
  @HostBinding('class')
  private readonly classes = 'flex flex-col w-full h-full bg-white border-l border-navy-40 overflow-hidden';

  readonly displayedData$ = new BehaviorSubject<ProfileResponse[]>([]);

  readonly searchDefinitions: SearchDefinitionModel<ProfileResponse>[] = [
    {
      propertyId: 'Profile-name',
      propertySelector: (profile: ProfileResponse) => profile.name,
    },
  ];

  profiles$: Observable<ProfileResponse[]>;

  constructor(
    private trustCenterFacadeService: TrustCenterFacadeService,
    private trustCenterModalsService: TrustCenterSharedModalsService,
  ) {}

  ngOnInit(): void {
    this.profiles$ = this.trustCenterFacadeService.getProfiles();
  }

  buildTranslationKey(key: string): string {
    return `trustCenter.permissionProfilesSettings.${key}`;
  }

  handleSearch(profiles: ProfileResponse[]): void {
    this.displayedData$.next(profiles);
  }

  openAddProfileModal(): void {
    this.trustCenterModalsService.openAddEditProfileModal();
  }
}
